"use strict";
import { trimToLength } from "utilities/src/primitives/string";
export class PlatformSplitStubError extends Error {
  constructor(functionName) {
    super(`${functionName} not implemented. Did you forget a platform override?`);
    this.name = this.constructor.name;
  }
}
export class NotImplementedError extends Error {
  constructor(functionName) {
    super(`${functionName} is not implemented on this platform.`);
    this.name = this.constructor.name;
  }
}
export function assert(predicate, errorMessage) {
  if (!predicate) {
    throw new Error(errorMessage);
  }
}
export function sanitizeErrorMessage(message) {
  if (!message) return message;
  const lines = message.split(/\r?\n/);
  const isNoisyStart = (line) => /^(request|url|version|details|docs|rawcallargs|contract call|call arguments)\b/i.test(line.trim());
  const filtered = [];
  let skipping = false;
  for (const line of lines) {
    const trimmed = line.trim();
    if (isNoisyStart(trimmed)) {
      skipping = true;
      continue;
    }
    if (skipping) {
      if (trimmed.length === 0) {
        skipping = false;
      }
      continue;
    }
    filtered.push(line);
  }
  const compact = filtered.join("\n").replace(/\n{3,}/g, "\n\n").trim();
  return compact;
}
export function errorToString(error, maxLength = 240) {
  let errorMessage = "";
  if (error instanceof Error) {
    errorMessage = error.message;
  } else if (typeof error === "string") {
    errorMessage = error;
  } else if (typeof error === "number") {
    errorMessage = `Error code: ${error}`;
  } else {
    const OMIT_KEYS = /* @__PURE__ */ new Set([
      "request",
      "config",
      "stack",
      "response",
      "cause",
      "options",
      "meta",
      "rawCallArgs"
    ]);
    const sanitizedJson = JSON.stringify(error, (key, value) => OMIT_KEYS.has(key) ? void 0 : value);
    errorMessage = sanitizedJson;
  }
  const sanitized = sanitizeErrorMessage(errorMessage);
  return trimToLength(sanitized, maxLength);
}
export function tryCatch(valueFnOrPromise) {
  if (valueFnOrPromise instanceof Promise) {
    return valueFnOrPromise.then((v) => tryCatch(() => v)).catch(
      (e) => tryCatch(() => {
        throw e;
      })
    );
  }
  try {
    return { data: valueFnOrPromise(), error: null };
  } catch (e) {
    return { data: null, error: e instanceof Error ? e : new Error(String(e)) };
  }
}
